<template>
  <div class="modal-wrapper" v-if="visible">
    <transition name="overlay">
      <div
        class="modal-overlay"
        :v-if="overlay"
        v-show="delayedVisible"
        @click="overlayClose ? closeModal() : null"
        :style="overlayClose ? 'cursor: pointer' : 'cursor: default'"
      ></div>
    </transition>
    <transition name="modal">
      <div
        class="modal-container"
        v-show="delayedVisible"
        :style="`height: ${bodyHeight}; width: ${bodyWidth}`"
      >
        <div class="modal-header">
          <h2 class="title">
            <i :class="`${titleIcon}`" :style="`font-size: ${titleIconSize}`" />
            {{ title }}
          </h2>
        </div>
        <div
          class="modal-body"
          :style="
            `${bodyScrollable ? 'overflow-y: scroll' : 'overflow-y: none'}; 
        ${bodyCenter ? 'justify-content: center; align-items: center' : null}`
          "
        >
          <slot />
        </div>
        <div class="modal-footer" :style="`height: ${footerHeight}`">
          <div>
            <el-checkbox v-model="neverShow" v-if="visibleNeverShowCheckbox">毎回このお知らせを表示しない</el-checkbox>
          </div>
          <div class="buttons">
            <button
              class="button white"
              v-if="closeButton"
              @click="closeModal"
            >{{ closeButtonText }}</button>
            <button class="button" v-if="agreeButton" @click="onClickAgree()">{{ agreeButtonText }}</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { db } from "@/plugins/firebase";

export default {
  props: {
    title: String,
    titleIcon: String,
    titleIconSize: {
      type: String,
      default: "1.4rem"
    },
    overlay: {
      type: Boolean,
      default: true
    },
    bodyScrollable: {
      type: Boolean,
      default: true
    },
    bodyHeight: {
      type: String,
      default: "500px"
    },
    bodyWidth: {
      type: String,
      default: "820px"
    },
    bodyCenter: {
      type: Boolean,
      default: true
    },
    footerHeight: {
      type: String,
      default: "60px"
    },

    titleIconColor: {
      type: String,
      default: "#FF8888"
    },
    closeButton: {
      type: Boolean,
      default: true
    },
    closeButtonText: {
      type: String,
      default: "閉じる"
    },
    agreeButton: {
      type: Boolean,
      default: true
    },
    agreeButtonText: {
      type: String,
      default: "決定"
    },
    neverShowContent: {
      type: String,
      default: null
    },
    visibleNeverShowCheckbox: {
      type: Boolean,
      default: true
    },
    overlayClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      delayedVisible: false,
      neverShow: false,
      neverShowVisible: true
    };
  },
  async mounted() {
    let self = this;
    setTimeout(() => {
      self.delayedVisible = true;
    }, 1000);
    try {
      const userRef = db
        .collection("users")
        .doc(this.$store.state.auth.user.uid);

      const userSnapshot = await userRef.get();
      const userData = userSnapshot.data();

      if (
        userData.neverShowContent &&
        userData.neverShowContent[self.neverShowContent] !== null
      ) {
        self.neverShow = userData.neverShowContent[self.neverShowContent];
      }
    } catch (err) {}
  },
  methods: {
    async onClickAgree() {
      this.$emit("agreeButtonClicked");
      let self = this;

      if (self.neverShowContent) {
        try {
          await db
            .collection("users")
            .doc(this.$store.state.auth.user.uid)
            .set(
              {
                neverShowContent: {
                  [self.neverShowContent]: self.neverShow
                }
              },
              { merge: true }
            );
        } catch (err) {
          console.log(err);
        } finally {
          self.closeModal();
        }
      }
    },
    showModal(hideNeverShow) {
      if (hideNeverShow) {
        this.neverShowVisible = false;
      }
      this.visible = true;
      setTimeout(() => {
        this.delayedVisible = true;
      }, 500);
    },
    closeModal() {
      this.delayedVisible = false;
      setTimeout(() => {
        this.visible = false;
      }, 500);
    },
    toggleModal() {
      this.visible = !this.visible;
    }
  }
};
</script>

<style lang="scss">
.modal {
  &-wrapper {
    z-index: 1400;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  &-overlay {
    z-index: 1300;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.43);
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    cursor: pointer;
  }
  &-container {
    /* overflow: hidden; */
    z-index: 2000;
    width: 820px;
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.3);
    border-radius: 25px;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &-header {
    border-radius: 5px 5px 0 0;
    height: 50px;
    background-color: rgb(245, 245, 245);
    padding: 5px 25px;
    border-bottom: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 1.2rem;
    }
  }

  &-body {
    padding: 5px 25px;
    height: 400px;
    display: flex;
    /* overflow-y: scroll; */
    background-color: white;
  }

  &-footer {
    padding: 5px 25px;
    border-radius: 0 0 5px 5px;

    background-color: rgb(245, 245, 245);
    border-top: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    button {
      margin-left: 20px;
    }
  }
}

// overlay animation

.overlay-enter-active,
.overlay-leave-active {
  transition: all 0.5s;
}
.overlay-enter,
.overlay-leave-to {
  opacity: 0;
}

// container animation

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}
.modal-enter,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
</style>
